import { render, staticRenderFns } from "./my-response.vue?vue&type=template&id=097d6d56&scoped=true&"
import script from "./my-response.vue?vue&type=script&lang=js&"
export * from "./my-response.vue?vue&type=script&lang=js&"
import style0 from "./my-response.vue?vue&type=style&index=0&id=097d6d56&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "097d6d56",
  null
  
)

export default component.exports